import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UrandaUiConfig } from '@uranda/ui';


@Component({
  selector: 'app-modal-player',
  styleUrls: ['modal-player.component.css'],
  templateUrl: 'modal-player.component.html',
  standalone: false
})
export class ModalPlayerComponent {

  constructor(protected modal: NgbActiveModal) {
    this.iconSet = UrandaUiConfig.config?.iconSet || 'ti';
    this.customIcons = UrandaUiConfig.config?.customIcons || {};
  }
  @Input() noBodyPadding = false;
  @Input() dismissable = true;
  @Input() showActions = true;
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() bodyPaddingTop = 3;

  @Input() iconSet: string = 'ti';
  @Input() customIcons: { [key: string]: string } = {};

  @Output() onClose = new EventEmitter<void>();

  close() {
    this.onClose.emit();
    this.modal.close();
  }

  protected getIcon(iconName: string): string {
    return this.customIcons[iconName] || iconName;
  }

}
